import { render, staticRenderFns } from "./EdicionFormasValoradas.vue?vue&type=template&id=6c162d9e&"
import script from "./EdicionFormasValoradas.vue?vue&type=script&lang=js&"
export * from "./EdicionFormasValoradas.vue?vue&type=script&lang=js&"
import style0 from "./EdicionFormasValoradas.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports